<template>
    <div class="LnkWcbForm-modal">
        <modal name="WebcallbackModal">
            <div class="LnkWcbForm-container modalPJ" v-if="categorie === 'Protection Juridique'">
                <div class="LnkWcbForm-container-hidden">
                    <div class="LnkWcbForm-header">
                        <span>
                            Rappel immédiat et gratuit<br>pour tout devis ou souscription
                        </span>
                    </div>
                    <b>{{ infoWcb.response }}</b>
                    <div v-if="erreur">{{ erreur }}</div>
                    <div class="LnkWcbForm-text">
                        <fieldset>
                            <div class="status-bar">
                                <div class="user-status"></div>
                            </div>
                            <div class="user-errors errors"></div>

                            <div class="champ-wcb mb-4">
                                <input type="text" v-model="phoneNumber" name="callee" placeholder="Votre n° de téléphone"
                                       class="LnkWcbForm-input-tel">
                                <button v-on:click="webCallBackRequest($event)" class="LnkWcbForm-bt-valider">
                                    Valider
                                </button>
                            </div>

                            <div class="PJ-WCB">
                                <p class="font-14">
                                    Pour un <strong class="">contrat déjà en cours</strong> ou <strong>un litige</strong>,<br>
                                    merci de nous contacter au <a href="tel:3222" class="font-20">32 22</a>
                                </p>
                            </div>
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="LnkWcbForm-container" v-else>
                <div class="LnkWcbForm-container-hidden">
                    <div class="LnkWcbForm-header">
                        <span>Rappel immédiat et gratuit !</span>
                    </div>
                    <b>{{ infoWcb.response }}</b>
                    <div v-if="erreur">{{ erreur }}</div>
                    <div class="LnkWcbForm-text">
                        <fieldset>
                            <div class="status-bar">
                                <div class="user-status font-16">
                                    <strong class="block">Un conseiller vous rappelle gratuitement</strong>
                                    pour répondre à vos questions.
                                </div>
                            </div>
                            <div class="user-errors errors"></div>

                            <div class="champ-wcb mt-3">
                                <label for="callee">Saisissez votre n° de téléphone et validez</label>
                                <input type="text" v-model="phoneNumber" name="callee" placeholder="Votre numéro"
                                       class="LnkWcbForm-input-tel">
                                <button v-on:click="webCallBackRequest($event)" class="LnkWcbForm-bt-valider">
                                    Valider
                                </button>
                            </div>
                        </fieldset>
                    </div>
                </div>
            </div>
        </modal>
    </div>

</template>

<script>

export default {
    name: "WebCallBackIsiComComponent",
    data() {
        return {
            categorie: '',
            phoneNumber: '',
            pe: '',
            infoWcb: '',
            erreur: ''
        }
    },

    mounted() {
        this.$root.$on('openModal', (categorie, pe) => {
            this.categorie = categorie;
            this.pe = pe
            this.$modal.show('WebcallbackModal');
        });
        this.$root.$on('addValeur', (valeur) => {
            (valeur != 'undefined') ? this.valeur = valeur : this.valeur = '';
        });
    },
    methods: {


        webCallBackRequest: function (event) {
            let date = new Date();
            let today = date.toLocaleDateString('fr') + '-' + date.getHours() + "h" + date.getMinutes();

            if (event) {
                event.preventDefault()
            }

            let regPhone = new RegExp('^(?:(?:\\+|00)33|0)\\s*[1-9](?:[\\s.-]*\\d{2}){4}$');
            let regPhoneSurtax = new RegExp('^(0|((00|\\+)?33))6([\\s.-]*06){4}$');
            if (regPhone.test(this.phoneNumber) && !regPhoneSurtax.test(this.phoneNumber)) {
                axios.post('/api/wcb-isi-com-call', {
                    telephone: this.phoneNumber,
                    informations: this.categorie,
                    pointEntree: this.pe
                }).then(response => {
                    this.infoWcb = response.data;

                    // Envoyer un événement à GA4
                    gtag('event', 'CallbackOk', {
                        'event_category': this.categorie,
                        'event_label': 'CallbackOk-' + today + this.categorie,
                        'event_valeur': this.valeur,
                    });

                    // Autres actions si nécessaire
                    $('.user-status')
                        .attr({'class': 'wcb_ok'})
                        .text('Votre demande a bien été transmise à notre équipe');
                    $('.champ-wcb').css({'display': 'none'});
                    $('.PJ-WCB').css({'display': 'none'});
                    setTimeout(function () {
                        $(document).ready(function () {
                            $('.vm--overlay').trigger('click');
                        });
                    }, 2500);
                }).catch(error => {
                    console.error("Erreur lors de la requête Axios :", error);
                    // Gérer l'erreur si nécessaire
                });
            } else {
                let text = 'Le numéro de téléphone n\'est pas valide.';
                if (regPhoneSurtax.test(this.phoneNumber)) {
                    text = 'Ce numéro de téléphone n\'est pas accepté.';
                }
                $('.user-status')
                    .attr({'class': 'wcb_echec'})
                    .text(text);
            }

        },
    },
}
</script>

